// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_94510dc3","p":"_2727a00","icon":"_3d088e5b"};